module.exports = __webpack_public_path__ + "img/9.7cd0778d.png";